import { useQueryClient } from "@tanstack/react-query";
import { User } from "../types/User";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const useGetFetchQuery = (key: any) => {
  const queryClient = useQueryClient();

  return queryClient.getQueryData(key);
};

function UseLivlyLeaseUser() {
  const dispatch = useDispatch();
  const data = useGetFetchQuery(["user", "me"]);
  const user: User = data as User;
  useEffect(() => {
    if (user) {
      dispatch({ type: "RECEIVE_USER_ME", user });
    }
  }, [user, dispatch]);

  return user;
}

export { UseLivlyLeaseUser };
